import { useState } from 'react';
import CommunityChart from "../../components/Community/CommunityChart";
import CommunityChartMobile from "../../components/Community/CommunityChartMobile";
import { ChevronRight } from 'lucide-react';
import { ChevronDown } from 'lucide-react';
import { Link } from "react-router-dom";

const data = {
  Crops: {
    options: ['Maize'],
    description: `Maize: What you should know before starting a maize farm – (Maize also known as corn or mielies) Maize farming is an agricultural process of growing maize (corn) in fields. Maize is the most important food crop in the world, and is the most important grain crop in developing countries.`,
  },
  Livestock: {
    options: ['Cattle', 'Goats', 'Poultry'],
    description: `Livestock farming involves raising animals like cattle, goats, and poultry for food or other products. Each type requires different methods, care, and resources.`,
  },
  Irrigation: {
    options: ['Drip Irrigation'],
    description: `Irrigation is essential for consistent crop growth, especially in arid regions. Drip irrigation helps save water and ensures roots receive moisture directly.`,
  },
  'Business skills': {
    options: ['Budgeting', 'Marketing'],
    description: `Farming is also a business. Learning skills like budgeting, marketing, and inventory can help farmers sustain and grow their farms.`,
  },
  'Climate smart': {
    options: ['Sustainable Farming'],
    description: `Climate-smart agriculture promotes practices that help reduce greenhouse gas emissions and adapt to changing climates.`,
  },
};
const CommunityPage1 = () => {
  const iconUrl = "https://res.cloudinary.com/dzngpgki4/image/upload/v1744892528/image_1591_res4vm.png";
  const bgUrl = "https://res.cloudinary.com/dzngpgki4/image/upload/v1745354722/image_ic67tz.png";

  const items = [
    { title: "SEED PROPAGATION", subtitle: "Provide quality seeds", image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745269750/image_xdlyyi.png" },
    { title: "DEVELOPMENT", subtitle: "Develop your farm", image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745269751/image-1_y90jol.png" },
    { title: "MARKET ACCESS", subtitle: "Sell Your Products", image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745269749/image-2_yrrtni.png" },
    { title: "SUPPORT", subtitle: "Meet Other Farmers", image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745269750/image-3_dzzyak.png" },
  ];
  const tabs = Object.keys(data);
  const [activeTab, setActiveTab] = useState('Crops');
  const [selectedOption, setSelectedOption] = useState(data[activeTab].options[0]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const images = [
    { id: 1, head: "Maize", description: "Maize production.", img: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745280536/image_far8aa.png" },
    { id: 2, head: "Tomato", description: "Tomato production", img: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745280535/image-1_wcyen0.png" },
    { id: 3, head: "Onions", description: "Onions production.", img: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745280535/image-2_hgmxwf.png" },
    { id: 4, head: "Beans", description: "Beans production", img: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745280535/image-3_zbnup8.png" },
  ];
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setSelectedOption(data[tab].options[0]);
    setDropdownOpen(false);
  };
  const renderDescription = () => {
    const description = data[activeTab].description;
    const [firstWord, ...rest] = description.split(':');
    return (
      <p className="md:text-[28px] text-[8px] text-black">
        <span className="font-bold text-[#979797]">{firstWord}:</span>{rest.join(':')}
        <a href='/Ubuntu'>
     <img src='https://res.cloudinary.com/dzngpgki4/image/upload/v1745316830/Expand_right_8_wsktu1.png' alt='kl' className='ml-auto md:w-6 md:h-6 w-2 h-2 md:-mt-10 ' />

     </a>
      </p>
    );
  };
  const filteredImages = images.filter((image) =>
    image.head.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const community = {
    title: "Afrika Community",
    location: "Nyika, Country",
    farmerCount: "12,001",
    category: "Fruits & Vegetables",
    code: "FNKEFA123456",
    rating: "4.3",
    reviews: "653",
  };

  return (
    <div className="bg-white w-full">

      <div className="px-4 md:px-24 pt-4">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
       <a href='/Communities'>
       <h1 className="text-[#FDBD26] font-bold text-[12px] md:text-[36px]">Communities</h1>
       </a>
          <h1 className="text-black font-normal text-[10px] md:text-[36px]">{community.code}</h1>
        </div>

        {/* Hero Banner */}
        <div className="relative w-full h-[180px] md:h-[622px] rounded-[10px] overflow-hidden mb-6">
          <img src={bgUrl} alt="Community" className="w-full h-full object-cover" />
          <div className="absolute bottom-4 md:bottom-8 left-4 md:left-8 text-white">
            <h2 className="font-bold text-[12px] md:text-[32px]">Grow Together , Thrive Together</h2>
            <p className="text-[10px] md:text-[24px]">“Connecting Namibian farmers to knowledge, tools, and each other.”</p>
          </div>
        </div>

        {/* Info Section */}
        <div className="flex md:flex-row justify-between gap-4 p-2">
          <div>
            <h1 className="font-bold text-[10px] md:text-[36px]">{community.title}</h1>
            <div className="flex items-center text-[10px] md:text-[32px] mt-1">
              <img src={iconUrl} alt="Map" className="w-[10px] h-[10px] md:w-[32px] md:h-[32px] mr-2" />
              <span>{community.location}</span>
            </div>
          </div>
          <div className="text-[10px] md:text-[32px]">
            <p>Farmers: {community.farmerCount}</p>
            <p>{community.category}</p>
          </div>
          <div className="text-[10px] md:text-[32px] text-right">
            <p>{community.code}</p>
            <div className="flex justify-end items-center mt-1">
              <span className="text-green-700 mr-2">★</span>
              <span>{community.rating} ({community.reviews})</span>
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="md:mt-6 mt-3 text-[8px] md:text-[32px] text-black leading-relaxed">
          <p>
            This community is well-known for its sustainable farming practices and reliance on traditional, non-mechanized methods of farming. The community farmers work together to grow crops, raise livestock, and support each other with labor and resources. We  form cooperative arrangements where we share equipment, knowledge, and help one another during planting and harvest seasons. The strong social bonds and emphasis on communal support are key characteristics of our farming community, allowing us to maintain a sustainable, small-scale agricultural system despite modern agricultural practices surrounding us.
          </p>
        </div>

        {/* Join Button */}
        <div className="flex justify-end mt-8">
          <div className="flex items-center">
            <p className="text-[8px] md:text-[24px] bg-[#FFBD26] text-white px-4 py-1 rounded-l-xl font-bold">Join community</p>
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745313431/Expand_right_7_jwhgib.png" alt="Expand" className="h-[20px] w-[32px] md:h-[44px] md:w-[55px] object-contain bg-[#152C24] md:p-2 p-1 rounded-r-xl" />
          </div>
        </div>

        {/* WHAT WE DO */}
        <div className="mb-6">
          <h2 className="text-[#FDBD26] font-bold text-[20px] md:text-[36px] mb-6">WHAT WE DO</h2>
          <div className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-4  gap-1 md:gap-4">
            {items.map((item, index) => (
              <div key={index} className="bg-[#F1F1F1] shadow-sm rounded-[6px] overflow-hidden hover:scale-[1.01] transition-transform cursor-pointer">
                <img src={item.image} alt={item.title} className="w-full h-[40px] md:h-[180px] object-cover" />
                <div className="md:p-3 p-[5px] flex justify-between items-center">
                  <div>
                    <h3 className="text-[6px] md:text-[20px] font-bold text-black">{item.title}</h3>
                    <p className="text-[4px] md:text-[20px] text-black md:-mt-2">{item.subtitle}</p>
                  </div>
                  <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745269998/Expand_right_3_j7n2vo.png" alt="arrow" className="w-[10px] h-[10px] md:w-[24px] md:h-[24px]" />
                </div>
              </div>
            ))}
          </div>
        </div>


      </div>
      <div>
        <div className='md:flex hidden  '>
          <CommunityChart />
        </div>
        <div className='md:hidden flex px-4'>
          <CommunityChartMobile />
        </div>


      </div>
      <div className="md:px-24 px-4 md:mt-0 -mt-8">
        <div>
          <h1 className="text-[#FFBD26] font-bold text-[10px] md:text-[36px]">SUCCESS FACTORS</h1>
          <h1 className="text-black font-bold text-[8px] md:text-[36px]">Fruit & Vegetable Farming</h1>
          <p className="text-[8px] md:text-[32px] font-normal md:mt-4 ">
            Quality Inputs. Using healthy seeds/seedlings, proper fertilizers, and pest control boosts plant health and yield. Consistent Water Supply. Efficient irrigation ensures steady growth, especially during dry periods. Good Farm Management. Timely planting, weeding, pruning, and harvesting are crucial for healthy crops and minimal losses. Knowledge & Skills. Understanding crop needs, soil health, and disease management improves productivity. Access to Markets. Being able to sell produce quickly and at good prices helps farmers stay profitable. Planning & Record-Keeping. Keeping track of costs, harvests, and sales helps with smart decision-making and growth.
          </p>
        </div>
        <div className="flex  items-center  md:justify-between md:w-full  w-[330px] md:flex-row">
          <div className="mb-4 md:mb-0 md:mt-5 mt-3">
            <h1 className="text-[#FFBD26] font-bold text-[10px] md:text-[36px]">SUPPORT FARMERS</h1>
            <p className="text-[8px] md:text-[24px] font-normal md:mt-1 md:w-[590px] leading-tight">
              Support farmers by buying from a community or donate to support community initiatives
            </p>
          </div>
          <div className="flex items-center justify-between  md:flex-nowrap md:mt-10 ">

            <div className="flex items-center flex-shrink-0 md:mb-0  md:pr-3 pr-1">
              <p className="text-[6px] md:text-[16px] md:w-[250px] bg-[#2E453D] text-white px-2 md:px-4 py-[2px] md:py-[9px] rounded-tl-md md:rounded-tl-xl rounded-bl-md md:rounded-bl-xl font-bold whitespace-nowrap">
                SHOP
              </p>

              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745313431/Expand_right_7_jwhgib.png"
                alt="Expand"
                className="w-[16px] h-[13px] md:h-[42px] md:w-[55px] object-contain bg-[#152C24] p-[4px] md:p-2 rounded-tr-md md:rounded-tr-xl rounded-br-md md:rounded-br-xl"
              />
            </div>
          <a href='/Adopt1'>
          <div className="flex items-center flex-shrink-0  md:mt-0">
              <p className="text-[6px] md:text-[16px]  md:w-[250px]  bg-[#FFBD26] text-white md:px-4 px-2 md:px-1 py-[3px] md:py-[9px] rounded-tl-md md:rounded-tl-xl rounded-bl-md md:rounded-bl-xl font-bold whitespace-nowrap flex items-center ">
                ADOPT-A-FARM
              </p>

              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745313431/Expand_right_7_jwhgib.png"
                alt="Expand"
                className="w-[16px] h-[13px] md:h-[42px] md:w-[55px] object-contain bg-[#152C24] p-[4px] md:p-2 rounded-tr-md md:rounded-tr-xl rounded-br-md md:rounded-br-xl"
              />
            </div>
          </a>
          </div>
        </div>
        <div className="md:mt-6 mt-3">
          <h1 className="font-bold text-[10px] md:text-[32px] ">ADOPT-A-FARM</h1>
          <div className="flex justify-between mt-3">
            {/* First Return */}
            <div className="flex items-center space-x-2">
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745273955/image_ven47y.png"
                alt="First Return Icon"
                className="md:w-[42px] md:h-[42px] h-[16px] w-[16px]"
              />
              <div>
                <div className="font-bold text-[8px] md:text-[24px]">First Return</div>
                <div className="md:text-[24px] text-[8px] text-black md:-mt-2">1 Year</div>
              </div>
            </div>

            {/* Returns / Year */}
            <div className="flex items-center space-x-2">
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745273955/image-1_nroqeg.png"
                alt="Returns / Year Icon"
                className="md:w-[42px] md:h-[42px] h-[16px] w-[16px]"
              />
              <div>
                <div className="font-semibold  text-[8px] md:text-[24px]">Returns / Year</div>
                <div className="md:text-[24px] text-[8px] text-black text-center md:-mt-2">15% - 25%</div>
              </div>
            </div>

            {/* Available stocks */}
            <div className="flex items-center space-x-2">
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745273955/image-2_mq0znc.png"
                alt="Available Stocks Icon"
                className="md:w-[42px] md:h-[42px] h-[16px] w-[16px]"
              />
              <div>
                <div className="font-semibold  text-[8px] md:text-[24px]">Available stocks</div>
                <div className="text-[24px] text-[8px] text-black text-right  md:-mt-2">102 Stocks left</div>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:gap-4 gap-1 mt-8">
          <div className="relative rounded-lg overflow-hidden shadow-md h-[130px] md:h-[300px]">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745274529/image_yqkbvj.png"
              alt="Shop from community"
              className="object-cover w-full md:h-[230px] h-[100px]"
            />
            <div className="absolute md:bottom-0 bottom-0 left-0 right-0 bg-[#2E453D]  text-white  flex justify-between items-center">
              <div className="md:px-4 px-2 md:py-2 py-1">
                <div className="font-bold text-[8px] md:text-[24px]">SHOP</div>
                <div className=" md:text-[24px]  text-[6px] -mt-1 md:-mt-2">Buy from Community</div>
              </div>
              <div className="md:w-[85px] w-[40px] md:py-6 py-2 bg-[#152C24] flex justify-center items-center">
                <ChevronRight className="w-4 h-4 md:w-10 md:h-10" />
              </div>
            </div>
          </div>

          <div className="relative rounded-lg overflow-hidden shadow-md  h-[130px] md:h-[300px]">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745274529/image-1_m5wdwp.png"
              alt="Adopt a farm"
              className="object-cover w-full md:h-[220px] h-[140px]"
            />
        <a href='/Adopt1'>
        <div className="absolute md:bottom-0 bottom-0 left-0 right-0 bg-[#2E453D]  text-white flex justify-between items-center">
              <div className="md:px-4 px-2 md:py-2 py-1 ">
                <div className="font-bold text-[8px] md:text-[24px]">ADOP-A-FARM</div>
                <div className="md:text-[24px] text-[6px] md:-mt-2">Donate to support a community project</div>
              </div>
              <div className="md:w-[85px] w-[40px] md:py-6 py-2 bg-[#152C24] flex justify-center items-center">
                <ChevronRight className="w-4 h-4 md:w-10 md:h-10" />
              </div>
            </div>
        </a>
          </div>
        </div>
        <div className="mx-auto md:mt-10 mt-4">
          <h2 className="md:text-[36px]  text-[10px] font-bold text-[#FFBD26] mb-4">RESOURCES</h2>
          <div className="grid grid-cols-2 sm:grid-cols-2 gap-6">
            <div>
              {/* Learn Section */}
              <div className="flex items-start space-x-3">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745275787/image_uemdze.png"
                  alt="Learn Icon"
                  className="md:w-10 md:h-10  w-4 h-4 mt-1"
                />
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <h3 className="md:text-[32px] text-[10px] font-bold">Learn</h3>
                    <ChevronDown className="md:w-6 md:h-6 h-2 w-2  text-gray-700" />
                  </div>
                </div>
              </div>
              <p className="md:text-[20px] text-[8px] text-black"><span className="text-[#979797] font-bold">Knowledge Hub:</span> “What do you want to learn today?”</p>

            </div>
            <div>
              {/* Tips Section */}
              <div className="flex items-start space-x-3">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745275786/image-1_c7cvoc.png"
                  alt="Tips Icon"
                  className="md:w-10 md:h-10 w-4 h-4 mt-1"
                />
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <h3 className="md:text-[32px]  text-[10px] backdrop:font-bold">Tips</h3>
                    <ChevronDown className="md:w-6 md:h-6 w-2 h-2 text-gray-700" />
                  </div>
                </div>
              </div>
              <p className="md:text-[20px] text-[10px] text-black">How to Start a Poultry Farm”</p>

            </div>
          </div>
        </div>
        <div>
          <div className="md:mt-8 mt-3">
            <div className="flex justify-between  mb-4">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => handleTabClick(tab)}
                  className={`md:text-[24px]  text-[6px] md:w-[240px] w-[62px] h-[20px] md:h-[55px] font-semibold  text-left md:px-4 px-1 pb-2 rounded-md border-b-[3px] ${activeTab === tab ? 'border-[#FDBD26] text-black' : 'border-[#979797] text-black'
                    }`}
                >
                  {tab}
                </button>
              ))}
            </div>

            <div className="space-y-0">
              <div className="relative inline-block text-left">
              <a href='/Ubuntu'>
                <div
                  className="flex items-center  md:w-[240px] justify-between  cursor-pointer  md:text-[24px] text-[10px] font-medium"

                >
                  <span>{selectedOption}</span>

<ChevronDown className="md:w-6 md:h-6 h-2 w-3  text-gray-600" />

                </div>
</a>
                {dropdownOpen && (
                  <div className="absolute z-10 mt-2 w-full bg-white">
                    {data[activeTab].options.map((option) => (
                      <div
                        key={option}
                        onClick={() => {
                          setSelectedOption(option);
                          setDropdownOpen(false);
                        }}
                        className="px-4 py-2 md:text-[24px] text-[10px] text-black hover:bg-gray-100 cursor-pointer"
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {renderDescription()}
            </div>
          </div>
        </div>

        <div className="flex justify-between items-start md:mt-12 mt-3">
          <div>
            <h1 className='text-[#FFBD26] font-bold  text-[10px] md:text-[36px]'>GALLERY</h1>
          </div> {/* Empty div to push the button to the right */}

          <div>
            <div className="flex items-center ml-auto pr-3 md:pr-0 md:mb-1">
              <p className="md:text-[16px] text-[5px] bg-[#FFBD26] text-white px-2 md:px-4 md:w-[255px] md:py-[9px] py-[3px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap">
                VIEW MORE
              </p>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                alt="Expand"
                className="w-[20px] h-[5px] md:h-[42px] md:w-[55px] hidden md:flex object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#152C24] px-2 md:py-2"
              />
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
                alt="Expand"
                className="w-[20px] h-[13px] md:hidden flex py-[1px] md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
              />
            </div>
          </div>
        </div>
        <div className=" mt-5 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-2 gap-2">
          {filteredImages.map((image) => (
            <Link
              key={image.id}
              to={
                image.id === 1 ? "/comms" :

                  image.id === 2 ? "/comms" :
                    image.id === 3 ? "/comms" :
                      image.id === 4 ? "/comms" :
                        image.id === 5 ? "/comms" :
                          image.id === 6 ? "/comms" :
                            image.id === 7 ? "/commsn" :
                              image.id === 8 ? "/comms" :
                                `/comms/${image.id}`
              }
              className="flex flex-col rounded-lg"
            >
              <div className="relative w-full">
                <img
                  src={`${image.img}`}
                  alt={image.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>

              <div className=" flex justify-between items-center">
                <div>
                  <p className="mt-2 text-left font-bold text-[10px] md:text-[24px]">{image.head}</p>
                  <p className="text-left font-normal text-[8px]  md:text-[24px] md:-mb-1 mb-2">{image.description}</p>
                </div>
              </div>

            </Link>

          ))}
        </div>
        <div>
          <div className="flex justify-between items-start md:mt-12 mt-3">
            <div>
              <h1 className='text-[#FFBD26] font-bold  text-[10px] md:text-[36px]'>COMMUNITY POSTS</h1>
            </div> {/* Empty div to push the button to the right */}

            <div>
              <div className="flex items-center ml-auto pr-3 md:pr-0 md:mb-1 mb-2">
                <p className="md:text-[16px] text-[5px] bg-[#FFBD26] text-white px-2 md:px-4 md:w-[255px] md:py-[9px] py-[3px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap">
                  VIEW MORE
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[42px] md:w-[55px] hidden md:flex object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#152C24] px-2 md:py-2"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
                  alt="Expand"
                  className="w-[20px] h-[13px] md:hidden flex py-[1px] md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
                />
              </div>
            </div>
          </div>
          <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745280537/image-4_j8scb5.png" className="w-full h-auto" alt="Community" />
          <div>
            <p className='md:text-[24px] text-[10px] font-normal md:mt-2 mt-1'>
              Farmer training - Connecting farmers to knowledge, tools, and each other.  <br />
              The Bigger Picture<br />
              Connecting  farmers in this way is about building resilience, improving livelihoods, and strengthening food security. It creates a support system where farmers aren’t just surviving—but growing, innovating, and thriving together.
            </p>
          </div>
        </div>

        <div className="mt-10 ">
          {/* Comment Heading */}
          <h2 className="md:text-[32px] text-[10px] font-bold mb-2">Comment</h2>

          {/* Large Input Field with Send Icon */}
          <div className="relative w-full h-full">
            <input
              type="text"
              placeholder="Type comment here......"
              className=" w-full md:h-[167px]  h-[80px] font-light md:text-[32px]  text-[8px] md:p-4  p-1 flex flex-col px-4 pr-12 border border-gray-300 rounded-[5px] focus:outline-none"
            />

            {/* Send Icon (Inside Input, Right-Aligned) */}
            <button className="absolute right-4 top-1/2 transform -translate-y-1/2">
              <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745280683/Send_hor_fill_tujl1b.png" alt="Send" className="md:w-[70px]  h-[20px] w-[20px] md:h-[70px]" />
            </button>
          </div>
        </div>
        <div className="flex flex-col md:space-y-6 space-y-2 mt-10">
          {/* First Section */}
          <div className="w-full  md:pb-10 pb-2">
            <div className="flex items-center space-x-[2%]">
              {/* Profile Image */}
              <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745280706/image-1_ykxdoz.png" alt="Maria Mona" className="md:w-[101px] md:h-[101px] w-[50px] h-[50px] rounded-full" />

              {/* Text Content */}
              <div className="flex-1">
                {/* Name & Date Section */}
                <div className="flex items-center justify-between">
                  <h2 className="md:text-[32px] text-[8px] font-semibold md:leading-[32px] text-black">Maria Mona</h2>
                  <div className="flex items-center space-x-6">
                    <a href="#" className="text-[#979797]  md:text-[32px] text-[8px] font-medium">2 Days ago</a>
                  </div>
                </div>

                <h3 className="md:text-[32px] text-[8px] font-medium md:leading-[32px] text-gray-500 mt-1">Go-Getter Entrepreneur</h3>
                <p className="md:text-[32px]  text-[8px] font-medium md:leading-[32px] text-black mt-2">
                  Way over due. Progressive community. Growing community = Prosperous community
                </p>
              </div>
            </div>
          </div>

          {/* Second Section */}
          <div className="w-full md:pb-6  pb-2 md:mt-5">
            <div className="flex items-center space-x-[2%]">
              {/* Profile Image */}
              <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745280706/image_tm5pkb.png" alt="John Doe" className="md:w-[101px] md:h-[101px]  h-[50px] w-[50px] rounded-full" />

              {/* Text Content */}
              <div className="flex-1">
                {/* Name & Date Section */}
                <div className="flex items-center justify-between">
                  <h2 className="md:text-[32px] text-[8px] font-semibold md:leading-[32px] text-black">John James</h2>
                  <div className="flex items-center space-x-6">
                    <a href="#" className="text-[#979797] md:text-[32px]  text-[8px] font-medium">3 Days ago</a>
                  </div>
                </div>

                <h3 className="md:text-[32px] -mt-2   text-[8px] font-medium leading-[32px] text-gray-500 md:mt-1">Get it done!</h3>
                <p className="md:text-[32px]  text-[8px]  font-medium md:leading-[32px] text-black md:mt-2">
                  Great stuff!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-between items-start md:mt-12 mt-3">
          <div></div> {/* Empty div to push the button to the right */}

          <div>
            <div className="flex items-center ml-auto pr-3 md:pr-0 md:mb-1">
              <p className="md:text-[16px] text-[5px] bg-[#FFBD26] text-white px-2 md:px-4 md:w-[255px] md:py-[9px] py-[3px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap">
                CONTACT ADMIN
              </p>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                alt="Expand"
                className="w-[20px] h-[5px] md:h-[42px] md:w-[55px] hidden md:flex object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#152C24] px-2 md:py-2"
              />
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
                alt="Expand"
                className="w-[20px] h-[13px] md:hidden flex py-[1px] md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
              />
            </div>
            <p className='md:text-[10px] text-[4px] font-normal md:mt-0 mt-1'>Contact administrator for more information</p>
          </div>
        </div>
        <div className="flex justify-between items-start border-b-[3px]  border-[#979797] rounded-md md:py-10 py-3 px-5 space-x-5 flex-wrap shadow-lg md:mt-0 mt-5">
          <div className="text-left text-xl sm:text-xl lg:text-2xl font-bold">
            <h1 className='text-black text-[8px] md:text-[32px]'>SDG No 8 <span className='text-[#979797]'>  : Jobs</span></h1>
            <h1 className="md:mt-3 font-normal leading-normal  text-[5px]  md:text-[32px] md:w-[990px] w-[200px]">Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all</h1>
          </div>
          <div className="md:w-20 w-16">
            <img src='https://res.cloudinary.com/dzngpgki4/image/upload/v1745280679/image_44_ircbsd.png' alt="Climate Action" className="md:w-full w-[25px] h-auto" />
          </div>
        </div>
        <div className='md:h-10 h-4'></div>
      </div>
    </div>
  );
};

export default CommunityPage1;